import { useState } from "react";
import { ScrollView } from "react-native";
import { Redirect, useRouter } from "expo-router";
import { useUnistyles } from "react-native-unistyles";

import { Button, View, FormInput } from "@src/components";
import { useTenantId } from "@src/features/tenants";
import { isProductionEnvironment } from "@src/utils/environment";

export default function CameraDetailsScreen() {
  const router = useRouter();
  const { theme } = useUnistyles();
  const tenantId = useTenantId();

  const [siteId, setSiteId] = useState("S2-test-site-001");
  const [cameraId, setCameraId] = useState("A2-G2-CAM_11142@camera-a");

  // Internal debug tooling — must never be reachable in the production app.
  if (isProductionEnvironment()) {
    return <Redirect href="/not-found" />;
  }

  const handleLoadCamera = () => {
    if (!siteId.trim() || !cameraId.trim()) {
      return;
    }

    router.push(
      `/tenants/${encodeURIComponent(tenantId)}/sites/${encodeURIComponent(siteId.trim())}/cameras/${encodeURIComponent(cameraId.trim())}`,
    );
  };

  const isLoadDisabled = !siteId.trim() || !cameraId.trim();

  return (
    <View flex={1} bg="background">
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{
          padding: theme.spacing["3xl"],
          gap: theme.spacing["3xl"],
        }}
      >
        <FormInput
          title="Site ID"
          placeholder="Enter Site ID"
          autoCapitalize="none"
          value={siteId}
          onChangeText={setSiteId}
        />

        <FormInput
          title="Camera ID"
          placeholder="Enter Camera ID"
          autoCapitalize="none"
          value={cameraId}
          onChangeText={setCameraId}
        />

        <Button
          label="Load Camera"
          size="md"
          variant="primary"
          variantColor="blue"
          onPress={handleLoadCamera}
          disabled={isLoadDisabled}
        />
      </ScrollView>
    </View>
  );
}
